// src/components/landingpage/pp-terminalx/TerminalXMark.jsx
//
// The TerminalX app icon as an inline SVG, for places that must not carry an
// <img> (the Downloads page renders feed text only, and its test proves no
// image element ever appears). The artwork is assets/images/terminalx/app.svg.
export default function TerminalXMark({ size }) {
  return (
    <svg viewBox="0 0 64 64" role="img" aria-label="TerminalX" width={size} height={size} style={{ display: 'block' }}>
      <rect x="4" y="4" width="56" height="56" rx="14" fill="#1a1f27" />
      <rect x="4" y="4" width="56" height="56" rx="14" fill="none" stroke="#2f80ed" strokeWidth="3" />
      <path d="M18 24l10 8-10 8" fill="none" stroke="#2f80ed" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M32 42h14" stroke="#c9d1d9" strokeWidth="5" strokeLinecap="round" />
    </svg>
  );
}
